/* global axios */
import ApiClient from './ApiClient';

class PlatformPolicyAPI extends ApiClient {
  constructor() {
    super('platform_policy', { accountScoped: true });
  }

  get(accountId) {
    return axios.get(`/api/v1/accounts/${accountId}/platform_policy`);
  }
}

export default new PlatformPolicyAPI();
